module.exports = __webpack_public_path__ + "static/media/47.69497556.jpeg";